/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2023 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import styled from "styled-components";
import { WithDottedBorder } from "components/shared/DottedBorder";
import { devices } from "components/shared/Styles";
import { BodyLarge } from "components/shared/SpectrumCss";
import "stylesheets/spectrum.scss";

type DottedDropzoneType = {
  dashlength: number;
  color: string;
  backgroundcolor: string;
  radius?: string | number;
  children: React.ReactNode;
};

export const Dropzone = styled(WithDottedBorder)<DottedDropzoneType>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius: ${(props): string =>
    props.radius ? `${props.radius}px` : "18px"};
  width: 561px;
  height: 405px;

  background-color: ${({ backgroundcolor }): string => backgroundcolor};
  ${devices.small} {
    width: calc(100vw - 48px);
    height: 100%;
    padding: 20px 0;
    margin-bottom: 20px;
  }
`;

export const DropzoneText = styled.h2.attrs({
  className: "spectrum-Heading spectrum-Heading--sizeM",
})<{
  marginBottomPx: number;
  marginTopPx: number;
}>`
  width: 290px;
  text-align: center;
  margin-bottom: ${({ marginBottomPx }): string => `${marginBottomPx}px`};
  margin-top: ${({ marginTopPx }): string => `${marginTopPx}px`};
  font-size: 22px;
  line-height: 130%;
`;

interface DropzoneInstructionsProps {
  marginBottomPx?: number;
  marginTopPx?: number;
}

export const DropzoneInstructions = styled(
  BodyLarge
)<DropzoneInstructionsProps>`
  font-size: 16px;
  line-height: 20px;
  color: var(--spectrum-global-color-gray-900);
  margin-bottom: ${({ marginBottomPx }): string => `${marginBottomPx ?? 0}px`};
  margin-top: ${({ marginTopPx }): string => `${marginTopPx ?? 0}px`};
  margin-left: 10px;
  margin-right: 10px;
  text-align: center;
`;
